module.exports = __webpack_public_path__ + "img/Viktoria.f46df888.png";